import { computed, inject, Injectable, Signal } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { LangChangeEvent, TranslateService } from '@ngx-translate/core';

@Injectable({
  providedIn: 'root',
})
export class CurrentLanguageSignalService {
  private translate: TranslateService = inject(TranslateService);

  langChange: Signal<LangChangeEvent | undefined> = toSignal(this.translate.onLangChange);
  languageButtonLabelSig: Signal<'en' | 'sk'> = computed<'en' | 'sk'>(() =>
    this.langChange() ? (this.translate.currentLang as 'sk' | 'en') : (this.translate.currentLang as 'sk' | 'en'),
  );
}
